import { useNavigate, useLocation } from 'react-router-dom';
import { Plus, AlertTriangle, Receipt, ArrowLeftRight } from 'lucide-react';
import { usePermissions } from '../contexts/PermissionsContext';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from '../components/ui/dropdown-menu';

const actions = [
  {
    id: 'issue',
    label: 'Report Issue',
    icon: AlertTriangle,
    path: '/dashboard/issues',
    permission: 'issues',
    iconColor: 'text-amber-500',
  },
  {
    id: 'expense',
    label: 'Log Expense',
    icon: Receipt,
    path: '/dashboard/expenses',
    permission: 'expenses',
    iconColor: 'text-rose-500',
  },
  {
    id: 'accounting',
    label: 'Add Accounting',
    icon: ArrowLeftRight,
    path: '/dashboard/money-in-out',
    permission: 'money_in_out',
    iconColor: 'text-emerald-500',
  },
];

const QuickActionButton = () => {
  const navigate = useNavigate();
  const { canCreate } = usePermissions();

  const visibleActions = actions.filter(a => canCreate(a.permission));
  if (visibleActions.length === 0) return null;

  const handleAction = (action) => {
    navigate(`${action.path}?action=create`);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium bg-blue-600 hover:bg-blue-700 text-white transition-colors"
          data-testid="quick-action-fab-toggle"
        >
          <Plus className="w-4 h-4" />
          <span className="hidden md:inline">Quick Add</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48" data-testid="quick-action-fab">
        {visibleActions.map((action) => {
          const Icon = action.icon;
          return (
            <DropdownMenuItem
              key={action.id}
              onClick={() => handleAction(action)}
              className="cursor-pointer"
              data-testid={`fab-${action.id}`}
            >
              <Icon className={`w-4 h-4 mr-2 ${action.iconColor}`} />
              {action.label}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default QuickActionButton;
